.stack {
	display: flex;
	align-items: center;
	gap: var(--size-3);
	padding: var(--size-1) 0;
	border-radius: var(--radius-lg);
	font-weight: 500;

	> div {
		flex: 1;
		display: flex;
		flex-direction: column;
	}
}

.sub {
	font-weight: normal;
	font-size: var(--text-caption);
	color: var(--color-text-subtle);
}
